export default __webpack_public_path__ + "static/media/marker-gray-sky-red.d244516d.png";